
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
    apiKey: "AIzaSyCQ07sz4zD9y-WsIjb2IlZY5jhWS7yl6ms",
    authDomain: "ceylon-eye-care-association.firebaseapp.com",
    projectId: "ceylon-eye-care-association",
    storageBucket: "ceylon-eye-care-association.firebasestorage.app",
    messagingSenderId: "165409977919",
    appId: "1:165409977919:web:a7b55d505df16115656a8a"
  };
  
  
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export